<template>
  <div class="labels-option">
    <div>
      <el-popover title="Alias" placement="right">
        <LabelsEditor
          :tags="tags"
          :type="type"
          :user-permissions="userPermissions"
          @add-tag="addTag"
          @delete-tag="deleteTag"
        />
        <side-bar-item
          slot="reference"
          :description="tooltipDescription"
          :type="type"
        >
          <template v-slot:icon="{ _class }">
            <font-awesome-icon
              slot="icon"
              :class="[_class, tags.length ? 'active' : '']"
              :icon="['fad', 'radar']"
            />
          </template>
        </side-bar-item>
      </el-popover>
    </div>
  </div>
</template>

<script>
import LabelsEditor from '../../LabelsEditor';
import SideBarItem from './SideBarItem';

export default {
  name: 'labels-option',
  components: {
    LabelsEditor,
    SideBarItem,
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => 'diagnostic',
    },
    userPermissions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tooltipDescription: this.$t(
        'knowledge.diagnostic-builder.side-bar.labels.tooltip',
      ),
    };
  },
  methods: {
    addTag(tag) {
      let tags = this.tags;
      tags.push(tag);
      this.$emit('update-content', { tags });
    },
    deleteTag(tag) {
      let tags = this.tags;
      tags.splice(tags.indexOf(tag), 1);
      this.$emit('update-content', { tags });
    },
  },
};
</script>
